<template>
  <div id="login">
    <a-layout class="layout-style">
      <!-- <a-layout-header style="background: #FFF;margin-right: 50px;">
        <a-row justify="end" align="middle">
          <GlobalOutlined class="ic-global" />
          <language-selector />
        </a-row>
      </a-layout-header> -->
      <a-layout-content>
        <a-row style="margin-top: 0px; height: 100%">
          <div class="login-swiper flex-align" :style="loginSwiperStyle">
            <!-- <img src="~@/assets/images/login-bg.png"> -->
            <!-- <img :src="loginImage" alt="Login Background"> -->
          </div>
          <div class="card-login">
            <div class="card-body">
              <div class="lang-sel">
                <GlobalOutlined class="ic-global" style="color: rgb(73, 86, 122);" />
                <language-selector style="color: rgb(73, 86, 122);" />
              </div>
              <div class="form-area">
                <div class="login-title">{{ $t('pages_login_005') }}</div>
                <div class="type-choose">
                  <div class="rectangle-selector">
                    <div
                      v-for="(item, index) in loginTypes"
                      :key="index"
                      :class="['region', { active: activeIndex === index }]"
                      @click="setActive(index)"
                    >
                      <div class="content">
                        <div :class="loginIconClass[index]" />
                        <div>{{ item }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <a-form
                  :model="loginState"
                  :rules="loginRules"
                  class="login-form ant-round-form login-form"
                  @finish="loginSuccess"
                >
                  <div class="login-label">{{ activeIndex === 0 ? $t('pages_login_017') : $t('pages_login_018') }}</div>
                  <a-form-item name="username">
                    <div style="position: relative">
                      <a-input
                        v-model:value="loginState.username"
                        style="position: relative"
                        :placeholder="activeIndex === 0 ? $t('pages_login_020') : $t('pages_login_019')"
                      />
                    </div>
                  </a-form-item>
                  <div class="forget-pwd-row">
                    <div class="login-label">{{ $t('pages_login_015') }}</div>
                    <div class="login-form-forgot"><span @click="() => sendVisible = true">{{ $t('pages_login_004') }}</span></div>
                  </div>
                  <a-form-item name="password">
                    <a-input-password
                      v-model:value="loginState.password"
                      :placeholder="$t('pages_login_003')"
                    />
                  </a-form-item>

                  <div v-if="resMsg" class="error-text">{{ resMsg }}</div>

                  <a-form-item v-if="needsCode" name="code">
                    <div class="flex-align">
                      <a-input
                        v-model:value="loginState.code"
                        style="border-radius: 3px"
                        :placeholder="$t('pages_login_008')"
                      />
                      <img class="code-src" :src="codeSrc" @click="loadValidateCode">
                    </div>
                  </a-form-item>

                  <a-form-item style="margin-top: 40px">
                    <a-button
                      style="width: 100%; background-color: rgb(73, 86, 122); border-color: rgb(73, 86, 122); color: #fff;"
                      shape="round"
                      type="primary"
                      html-type="submit"
                      :loading="loading"
                    >{{ $t('pages_login_016') }}</a-button>
                  </a-form-item>
                  <!-- <a-form-item style="text-align: center; margin-top: -18px;  font-size: 12px">
                    <span style="color: #999">{{ $t('pages_login_006') }}</span>
                    <span class="main-text-color" style="cursor: pointer" @click="$router.push('/register')">{{ $t('pages_login_007') }}</span>
                  </a-form-item> -->
                </a-form>
              </div>
            </div>
            <div class="keep-record">
              <div v-if="themeData.address">{{ themeData.address }}</div>
              <a target="_blank" href="https://beian.miit.gov.cn">{{ themeData.copyRight }}</a>
            </div>
          </div>
        </a-row>
      </a-layout-content>
    </a-layout>
    <!-- <div class="keep-record">
      <div v-if="themeData.address">{{ themeData.address }}</div>
      <a target="_blank" href="https://beian.miit.gov.cn">{{ themeData.copyRight }}</a>
    </div> -->
    <password-forget
      v-model:send-visible="sendVisible"
      v-model:succ-visible="succVisible"
    />
    <slide-verify
      v-model:visible="visible"
      @success="loginSuccess"
    />
  </div>
</template>
<script>
import LangSelector from '@/components/lang-sel'
import PasswordForget from './components/password-forget'
import SlideVerify from '@/components/slide-verify'
import { ref, reactive, inject, defineComponent, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { _login } from '@/api'
import { getIdentyImg } from '@/util'
import i18n from '@/locale'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Login',
  components: {
    'password-forget': PasswordForget,
    'slide-verify': SlideVerify,
    'language-selector': LangSelector
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const resMsg = ref('')
    const needsCode = ref(false)
    const codeSrc = ref('')
    const sendVisible = ref(false)
    const succVisible = ref(false)
    const loading = ref(false)
    const visible = ref(false)
    const loginTypes = ref([i18n.global.t('pages_login_017'), i18n.global.t('pages_login_018')])
    const activeIndex = ref(1)
    const loginIconClass = ref(['clarity--mobile-solid', 'mdi--email-outline'])

    const { locale } = useI18n()

    const loginImage = computed(() => {
      switch (locale.value) {
        case 'en':
          return require('@/assets/images/en-bg.jpg')
        case 'zh':
          return require('@/assets/images/cn-bg.jpg')
        default:
          return require('@/assets/images/en-bg.jpg')
      }
    })

    const setActive = (index) => {
      console.log('index', index)
      activeIndex.value = index
    }

    const themeData = inject('$themeData')

    const loginState = reactive({
      areacode: '+86',
      username: '',
      password: '',
      code: ''
    })

    const loginRules = {
      username: [{ required: true, trigger: 'change', message: i18n.global.t('pages_login_002') }],
      password: [{ required: true, trigger: 'change', message: i18n.global.t('pages_login_003') }],
      code: [{ required: true, trigger: 'change', message: i18n.global.t('pages_login_008') }]
    }

    const loginSuccess = async (e) => {
      resMsg.value = ''
      loading.value = true
      visible.value = false
      const data = {
        userName: loginState.username,
        password: loginState.password,
        code: loginState.code
      }
      if (e.sliderFlag) data.sliderFlag = e.sliderFlag
      try {
        const res = await _login.login(data)
        if (res.data.succ) {
          succDeal(res.data.data)
        } else {
          loading.value = false
          resMsg.value = res.data.resMsg
          if (['010001', '010006'].includes(res.data.resCode)) {
            needsCode.value = true
            loadValidateCode()
          }
        }
      } catch (e) {
        console.log(e)
        loading.value = false
      }
    }

    const loadValidateCode = () => {
      loginState.code = ''
      codeSrc.value = getIdentyImg(loginState.username)
    }

    const succDeal = async (data) => {
      const { menuList, userInfo, status, authFlag, activityStatus, entrySliderFlag } = data
      if (entrySliderFlag) {
        visible.value = true
        loading.value = false
      } else if (authFlag) {
        userInfo.status = status
        store.commit('updateMenuList', menuList)
        store.commit('updateUserInfo', userInfo)
        if (userInfo.mobile) {
          localStorage.setItem('mobileStatus', true)
          router.push('/home/index')
        } else {
          router.push('/user/account_materials')
        }
        await store.dispatch('getLanguage')
        loading.value = false
      } else {
        if (activityStatus === '40') {
          router.push('/guide_success')
        }
      }
    }

    const loginSwiperStyle = computed(() => {
      return {
        backgroundImage: `url(${loginImage.value})`
      }
    })

    const init = () => {
      if (route.query.source) {
        _login.loginCheck()
          .then(res => {
            if (res.data.succ) succDeal(res.data.data)
          }).catch(err => console.log(err))
      }
    }

    init()

    return {
      themeData,
      resMsg,
      needsCode,
      codeSrc,
      loading,
      visible,
      sendVisible,
      succVisible,
      loginState,
      loginRules,
      loginSuccess,
      loadValidateCode,
      loginTypes,
      setActive,
      activeIndex,
      loginIconClass,
      loginImage,
      locale,
      loginSwiperStyle
    }
  }
})
</script>
<style lang="less" scoped>
#login {
  .scrollbar-none;
  height: 100vh;
  overflow-y: scroll;
  .ic-global {
    color: @main-color;
  };
  .logo {
    width: 180px;
  };
  .login-swiper {
    flex: 0.8;
    height: 100%;
    justify-content: flex-start;
    background-color: rgb(246, 248, 251);
    background-size: auto 100%;
    // background-position: center;
    background-repeat: no-repeat;

    // img {
    //   width: 100%;
    //   height: 100%;
    //   object-fit: contain;
    // }
  }
  .card-login {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: left;
    // margin-left: 49px;
    background: rgb(246, 248, 251);
    padding: 0px 63px 0 44px;
    position: relative;
    align-content: space-around;
    justify-content: center;
    align-items: center;
    width: 100%;
    .card-body {
      width: 600px;
      background: #fff;
      //margin: 30px 0 0 37px;
      display: flex; /* 启用flex布局 */
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中，如果需要 */
      padding: 40px 120px; /* 假设左右两边各留50px的空白 */
      margin: 0 50px; /* 自动调整边距以实现居中 */
      flex-direction: column; /* 子元素垂直排列，如果需要 */
      position: relative;
      .lang-sel {
        display: flex;
        align-items: center;
        margin: 10px;
        position: absolute;
        top: 0;
        right: 0;
        color: rgb(73, 86, 122) !important;
      }
      .form-area{
        display: flex;
        flex-direction: column;
        width: 400px;
        .login-title {
          padding-left: 0px;
          font-size: 20px;
          font-weight: bold;
          color: #000;
          margin-bottom: 20px;
          align-self: flex-start;
        }
        .login-form {
          width: 100%;
        }
        .login-choose {
          width: 400px;
          margin-bottom: 10px;
        }
      }
      .error-text {
        color: @error-color;
        margin: -18px 0 12px 0;
      }
      .login-label {
        font-size: 14px;
        font-weight: 500;
        color: #000;
        margin-bottom: 10px;;
      }
      .login-form-forgot {
        font-size: 12px;
        font-weight: 500;
        color: @main-color;
        text-align: right;
        margin-top: -10px;
        text-decoration: underline;
        color: rgb(226, 206, 147);
        span {
          cursor: pointer;
        }
      }
      .code-src {
        margin: 0 18px 0 36px;
        height: 30px;
        cursor: pointer;
      }
    }
  }

  .forget-pwd-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .keep-record {
    text-align: center;
    color: #9c9d9c;
    padding-top: 128px;
    a {
      color: #9c9d9c;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
#login::-webkit-scrollbar {
  display: none;
}
.type-choose {
  width: 100%;
  margin-bottom: 20px;
  .rectangle-selector {
    position: relative;
    border: 1px solid #d7d3d3;
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    height: 35px;
  }

  .region {
    flex: 1;
    border-right: 1px solid #d7d3d3;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-weight: bold;
    cursor: pointer;
    // border: 1px solid #d7d3d3;
  }
  .region.active {
    border-color: rgb(226, 206, 147); /* 设置活动区域的边框颜色 */
    color: rgb(226, 206, 147); /* 设置活动区域的文本颜色 */
    border-right-color: rgb(226, 206, 147);
  }
  .region:last-child {
    border-right: none;
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
.clarity--mobile-solid {
  display: inline-block;
  width: 1.1em;
  height: 1.1em;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 36'%3E%3Cpath fill='%23000' d='M25 4H11a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-6 26h-2v-2h2Zm-8-4V6h14v20Z' class='clr-i-solid clr-i-solid-path-1'/%3E%3Cpath fill='none' d='M0 0h36v36H0z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  padding-right: 20px;
}
.mdi--email-outline {
  display: inline-block;
  width: 1.1em;
  height: 1.1em;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  padding-right: 20px;
}

/* Media Queries for Responsive Design */
@media (max-width: 768px) {
  .card-login {
    padding: 0px 20px !important;
    .card-body {
      width: 100% !important;
      padding: 20px !important;
      margin: 0 !important;
    }
    .form-area {
      width: 100% !important;
    }
  }
  .login-swiper {
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
}

@media (max-width: 480px) {
  .card-login {
    padding: 0px 10px !important;
    .card-body {
      width: 100% !important;
      padding: 10px !important;
      margin: 0 !important;
    }
    .form-area {
      width: 100% !important;
    }
  }
  .login-swiper {
    display: none !important;
  }
}
</style>
